// Admin Authentication Utility
// This file handles admin authentication via Firebase Auth

import { 
  signInWithEmailAndPassword, 
  signOut, 
  GoogleAuthProvider, 
  signInWithRedirect 
} from "firebase/auth";
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../firebase';

/**
 * Checks if an email is in the trusted admins collection
 * @param {string} email 
 * @returns {Promise<boolean>}
 */
const checkIfAdminExists = async (email) => {
  try {
    const normalizedEmail = email.trim().toLowerCase();
    const adminDocRef = doc(db, 'admins', normalizedEmail);
    const adminDoc = await getDoc(adminDocRef);
    return adminDoc.exists();
  } catch (error) {
    console.error('Error checking admin status:', error);
    return false;
  }
};

/**
 * Sign in admin using Firebase Auth (Email/Password)
 * @param {string} email - The admin email
 * @param {string} password - The admin password
 * @returns {Promise<boolean>} - True if sign in and admin check are successful
 */
export const loginAdmin = async (email, password) => {
  if (!email || !password) {
    return false;
  }

  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;
    
    // Verify if this user is in the admins collection
    const isAdmin = await checkIfAdminExists(user.email);
    if (!isAdmin) {
      await signOut(auth); // Sign them out immediately if they aren't an admin
      console.warn('Unauthorized access attempt by:', user.email);
      return false;
    }
    
    return true;
  } catch (error) {
    console.error('Error logging in admin:', error.message);
    return false;
  }
};

/**
 * Sign in admin using Google Auth Redirect
 */
export const loginWithGoogle = async () => {
  try {
    const provider = new GoogleAuthProvider();
    await signInWithRedirect(auth, provider);
  } catch (error) {
    console.error('Error initiating Google redirect:', error.message);
    alert('حدث خطأ أثناء محاولة الدخول عبر جوجل.');
  }
};

/**
 * Sign out admin
 */
export const logoutAdmin = async () => {
  try {
    await signOut(auth);
    sessionStorage.removeItem('adminAuthenticated');
    return true;
  } catch (error) {
    console.error('Error logging out admin:', error.message);
    return false;
  }
};
